import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import {search} from 'react-icons-kit/icomoon/search';
import SvgIcon from 'react-icons-kit';
import ModalPhenotype from './modalPhenotype';

var Config = require('../../../config');

class ModalReserve extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.validateInput = this.validateInput.bind(this);
		this.loadComponent = this.loadComponent.bind(this);
		this.addComponent = this.addComponent.bind(this);
		this.viewPhenotypes = this.viewPhenotypes.bind(this);
		this.addToList = this.addToList.bind(this);
		this.compatibleChange = this.compatibleChange.bind(this);

		this.state = {
			show: false,
			isLoading: false,
			no_file: "",
			patient:"",
			table_reserve:[],
			patient_grh:"",
			unit_number: "",
			components:[],
			component:{}
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){
		this.props.waiting.handleShow('Cargando...');

		fetch(Config.default.apiGateway.URL+'petitions?id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				var table = [];

				/*response.petitions_blood_components.map((c)=>{
					for(var i=0; i < c.amount; i++){						
						table.push({
							component_id: "",
							component: c.component_type.replace('_', ' '),
							component_type: c.component_type,
							component_number:"",
							cant: 1,
							rh_group_patient: response.person.lookup_group !== null ?
												response.person.lookup_group + (
													response.person.lookup_rh === 'POSITIVO' ?
														'+'
													: response.person.lookup_rh === 'NEGATIVO' ?
														'-'
													: ''
												)
												: '',
							unit_id:"",
							unit_number:"",
							id: c.id,
							rh_group_unit:"",
							compatible: "",
							phenotype: "",
							disabled: true,
						});
					}		
				});*/


				this.setState({
					petition_id: id,
					no_file: response.patient.number,
					patient: response.person.names+' '+response.person.lastname1+' '+response.person.lastname2,
					blood_components: response.petitions_blood_components !== undefined ? response.petitions_blood_components : [],
					table_reserve: table,
					patient_grh:response.person.lookup_group !== null ?
								response.person.lookup_group + (
									response.person.lookup_rh === 'POSITIVO' ?
										'+'
									: response.person.lookup_rh === 'NEGATIVO' ?
										'-'
									: ''
								)
								: ''
				});
				this.getUnitRerved(id);
			}
		});
	}

	getUnitRerved(id){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'unit_reserved/by_petition?id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.setState({show:true});

				response.map((res, i)=>{
					var index = this.state.table_reserve.findIndex(obj => {
						return (obj.component_type === res.blood_component.component_type.replace(' ', '_') &&
								obj.unit_id === "")
					})

					if(index !== -1){
						this.state.table_reserve[index].unit_id 		 = res.unit.id;
						this.state.table_reserve[index].unit_number 	 = res.unit.unit_number;
						this.state.table_reserve[index].component_number = res.unit.component_number;
						this.state.table_reserve[index].disabled 		 = false;
						this.state.table_reserve[index].rh_group_unit 	 = res.unit.group+
																			(res.unit.rh === 'POSITIVO' ? '+' :
																			res.unit.rh === 'NEGATIVO' ? '-' : '');
						this.state.table_reserve[index].compatibility 		 = res.unit_reserved.compatibility;
					}else{
						this.state.table_reserve.push({
							component_id: "",
							component: res.blood_component.component,
							component_type: res.blood_component.component_type,
							component_number:res.unit.component_number,
							cant: 1,
							rh_group_patient:this.state.patient_grh,
							unit_id: res.unit.id,
							unit_number: res.unit.unit_number,
							rh_group_unit: res.unit.group+
											(res.unit.rh === 'POSITIVO' ? '+' :
											res.unit.rh === 'NEGATIVO' ? '-' : ''),
							compatibility: res.unit_reserved.compatibility,
							phenotype: "",
							disabled: false,
						})
					}
				});

				this.forceUpdate();
			}
		});	
	}

	handleClose(){
		this.setState({
			show: false,
			isLoading: false,
			no_file: "",
			patient:"",
			table_reserve:[],
			unit_number: "",
			components:[],
			component:{}
		});
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		if(e.target.name === 'unit_number'){
      			this.getUnitComponent();
      		}

      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);
    		
    		if(form.elements[index + 1] !== undefined){
    			form.elements[index + 1].focus();
    		}

      	}
   	}

   	getUnitComponent(){
   		if(this.state.unit_number !== ""){
   			this.props.waiting.handleShow('Cargando...');
	   		fetch(Config.default.apiGateway.URL+'units/to_reserve?unit_number='+this.state.unit_number+
	   			'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
	   			method: 'GET',
	   			headers: new Headers({
	   				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
	   				'Accept'		: 'application/json',
	   				'Content-Type'	: 'application/json'
	   			})
	   		}).then(res => {
	   			this.props.waiting.handleClose();
	   			if(res.ok){
	   				return res.json();
	   			}else{
	   				res.text().then((msg)=>{
	   					swal('Error', msg, 'error');
	   				});
	   			}
	   		}).then(response => {
	   			if(response !== undefined){
	   				this.setState({components: response});
	   			}
	   		});

   		}else{
   			swal('Error', 'Debe de ingresar un número de unidad', 'error');
   		}
   	}

	handleSearch = (query) => {
	    this.setState({isLoading: true});
	    
		fetch(Config.default.apiGateway.URL+'units/search?unit_number='+query,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			response.map((item)=>{
				item.label = item.unit_number+' - '+item.component_type+' - '+item.component_number
			});

			this.setState({units_list: response});
		})
	}

	onChange(e){
		if(e.length > 0){
			this._typeahead.getInstance().clear();
			var index = this.state.table_units.findIndex(obj => obj.unit_id === e[0].id);

			if(index === -1){
				this.setState({
					table_units: [
						...this.state.table_units,
						{
							unit_id:e[0].id,
							unit: e[0].unit_number,
							component: e[0].component_type,
							component_number: e[0].component_number
						}
					],
					isLoading: false
				});
			}else{
				swal('¡La unidad no se puede agregar!', '¡Ya se ingreso esa unidad!', 'error');
			}	
		}
	}

	removeUnitFromList = (indice) => {
		var array = [...this.state.table_units];
		array.splice(indice, 1);
		this.setState({table_units: array});
	}

	onSave(){
		var method = '';
		var api = '';
		var num_units = 0;
		var num_comp = 0

		this.state.table_reserve.some((t)=>{
			if(t.unit_id === ""){
				num_units++;
			}

			if(t.compatibility === "" && t.unit_id !== ""){
				num_comp++;
			}
		});

		if(num_units === this.state.table_reserve.length-1){
			swal('¡El registro no se puede agregar!', '¡Ingrese una unidad!', 'error');
		}else if(num_comp !== 0){
			swal('¡El registro no se puede agregar!', 'Seleccione una opción compatibilidad', 'error');
		}else{
			var units = [];

			this.state.table_reserve.map((t)=>{
				if(t.unit_id !== ""){
					units.push({
						petition_blood_component_id: t.id !== undefined ? t.id : "",
						unit_id: t.unit_id,
						petition_id: parseInt(this.state.petition_id),
						compatibility: t.compatibility
					});
				}	
			});	

			method = 'POST';
			api = 'unit_reserved';
			
			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+api,{
				method: method,
				body: JSON.stringify(units),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().the((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				swal("Correcto", "Registro guardado correctamente", 'success');
				this.handleClose();
			});
		}
	}

	loadComponent(e){
		if(e.length > 0){
			this.setState({component: e[0]});
		}
	}

	addComponent(e){
		if(e.key === 'Enter'){
			setTimeout(function(){
				this.addToList();
			}.bind(this), 500);
		}
	}

	addToList(){
		if(JSON.stringify(this.state.component) !== '{}'){
			var index = this.state.table_reserve.findIndex(obj => {
				
				return obj.unit_id === "" && obj.component_type === this.state.component.blood_component.component_type?
					true
				: (obj.unit_id === this.state.component.unit.id && 
					obj.component_type === this.state.component.blood_component.component_type)
			});

			if(index === -1){
				this.setState({
					table_reserve: [...this.state.table_reserve, {
						component_id: this.state.component.blood_component.id,
						component: this.state.component.blood_component.component_type.replace('_', ' '),
						component_type: this.state.component.blood_component.component_type,
						component_number: this.state.component.component_number,
						cant: 1,
						rh_group_patient: this.state.table_reserve[0].rh_group_patient,
						unit_id:this.state.component.unit.id,
						unit_number:this.state.component.unit.unit_number,
						rh_group_unit:this.state.component.group !== null ?
										this.state.component.group + (
											this.state.component.rh === 'POSITIVO' ?
												'+'
											: this.state.component.rh === 'NEGATIVO' ?
												'-'
											: ''
										)
										: '',
						compatibility: "",
						phenotype: "",
						disabled: false,
					}],
					component:{},
					unit_number:"",
					components:[],
				});
				this._typeahead.getInstance().clear();
			}else{

				if(this.state.table_reserve[index].unit_id === ""){
					this.state.table_reserve[index].component_id = this.state.component.blood_component.id;
					this.state.table_reserve[index].component_number = this.state.component.component_number;
					this.state.table_reserve[index].unit_id = this.state.component.unit.id;
					this.state.table_reserve[index].unit_number = this.state.component.unit.unit_number;
					this.state.table_reserve[index].rh_group_unit = this.state.component.group !== null ?
																		this.state.component.group + (
																			this.state.component.rh === 'POSITIVO' ?'+'
																			: this.state.component.rh === 'NEGATIVO' ? '-'
																			: ''
																		): '';
					this.state.table_reserve[index].disabled = false;

					this.forceUpdate();

					setTimeout(()=>{
						this.setState({
							component: {},
							unit_number: "",
							components:[]
						});
					}, 1000)
					
					this._typeahead.getInstance().clear();

				}else if(this.state.table_reserve[index].unit_id === this.state.component.unit.id){
					swal('Error', 'La unidad ya fue ingresada', 'error');
					this._typeahead.getInstance().clear();
				}
			}
		}else{
			swal('Error', 'Debe de ingresar un número de unidad válido', 'error');
		}			
	}

	viewPhenotypes(){
		this.modal_phenotype.handleShow();
	}

	compatibleChange(e, index){
		this.state.table_reserve[index].compatibility = e.target.value === "true" ? true : e.target.value === "false" ? false : "";
		this.forceUpdate();
	}

	render(){
		const {t} = this.props;

		return (
			<Modal bsSize="lg" backdrop="static" keyboard={false} show={this.state.show} onHide={this.handleClose}>
				<Modal.Header>
					<Modal.Title>Reserva de Unidades</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<form noValidate>
							{/*<div className="col-xs-12">
								<div className="col-xs-12 col-sm-3" style={{textAlign:"right"}}>
									<span className="span-min">Número de Expediente</span>
								</div>
								<div className="col-xs-12 col-sm-9">
									<span>{this.state.no_file}</span>
								</div>
							</div>
							<div className="col-xs-12">
								<div className="col-xs-12 col-sm-3" style={{textAlign:"right"}}>
									<span className="span-min">Nombre de Paciente</span>
								</div>
								<div className="col-xs-12 col-sm-9">
									<span>{this.state.patient}</span>
								</div>
							</div>
							<div className="col-xs-12" style={{paddingTop:"10px"}}>
								<div className="col-xs-12 col-sm-3" style={{paddingTop:"28px"}}>
									<span className="span-min">Componentes Solicitados</span>
								</div>
								<div className="col-xs-12 col-sm-3">
									<span className="span-min">No. Unidad</span>
									<input type="text" className="form-control" name="unit_number" id="unit_number"
										value={this.state.unit_number} onChange={this.handleChange} onKeyPress={(e) => this.validateInput(e)} />
								</div>
								<div className="col-xs-12 col-sm-3">
									<span className="span-min">No. Componente</span>
									<AsyncTypeahead
							          labelKey={(option) => `${option.label}`}
							          minLength={0}
							          maxLength={50}
							          name="components"
							          id="components"
							          options={this.state.components}
							          onChange={this.loadComponent}
							          onKeyDown={this.addComponent}
							          ref={ref => this._typeahead = ref}
							          isLoading={this.state.isLoading}
							          useCache={false}
							        />
								</div>
								<div className="col-xs-12 col-sm-1" style={{paddingTop:"18px"}}>
									<button type="button" className="btn btn-info" onClick={this.addToList}>
										Agregar
									</button>
								</div>
							</div>
							<hr style={{width:"100%"}} />*/}

							<div className="col-xs-12">
								<Table responsive hover>
									<thead>	
										<tr>
											<th>Cant.</th>
											<th>Componente</th>
											<th>Grupo & RH</th>
											<th>No. Unidad</th>
											<th>No. Componente</th>
											<th>Grupo & RH Unidad</th>
											<th>Compatible</th>
											<th>Fenotipos</th>
										</tr>
									</thead>
									<tbody>
										{this.state.table_reserve.map((t, i)=>{
											return <tr key={i}>
												<td>{t.cant}</td>
												<td>{t.component}</td>
												<td align="center">{t.rh_group_patient}</td>
												<td>{t.unit_number}</td>
												<td align="center">{t.component_number}</td>
												<td align="center">{t.rh_group_unit}</td>
												<td>
													{t.compatibility}
												</td>
												<td align="center">
													<SvgIcon icon={search} style={{cursor:"pointer"}} disabled={t.disabled}
														onClick={this.viewPhenotypes} />
												</td>
											</tr>
										})}
									</tbody>
								</Table>
							</div>
						</form>
					</div>

					<ModalPhenotype {...this.props} onRef={ref => (this.modal_phenotype = ref)} />
				</Modal.Body>
				<Modal.Footer>
					{/*<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.onSave} />*/}
					<FlatButton primary={true} label={t('content.generics.buttons.close')} onClick={this.handleClose} /> 
				</Modal.Footer>
			</Modal>
		)
	}
}

export default translate('translations') (ModalReserve);